import styled from 'styled-components'
import { SimpleProduct } from './SimpleProduct'

const DispatchStyle = styled.div`

border: 1px solid #DCDCDC;
border-radius: 6px;
padding-bottom:  4px;
margin-bottom: 1rem;
.card-header {
    padding: 0.6rem 1rem;
    border-bottom: 1px solid #DCDCDC;
}
.card-body {
    position: relative;
    padding: 0.6rem 1rem;;
    gap: 20px;
}
.card-body  a {
    width: 100%;
    display: flex;
}
.card-body p {
    font-size: 14px;
    line-height: 1.4;
}

.order-notice {
    margin-bottom: 6px;
}
.order-notice p strong {
    font-size: 16px;
}
.hide strong{
    letter-spacing: 3px;
    font-size: 16px !important;
}

button {
    background: #E0004D;
    height: 40px;
    border: none;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;
    font-weight: 700;
    font-size: 16px;
    margin: 1rem auto 0;
    min-width: 75%;
}

.dayOf {
  font-size: 14px;
}

.pendiente,
.preparacion,
.stock,
.colored {
    color: #310393;
    font-size: 14px;
}
.transito {
    color: #ff9800 !important;
    font-size: 14px;
}
.entregado,
.finalizado {
    color: #4caf50 !important;
    font-size: 14px;
}
.anulado {
    color: #e31506 !important;
    font-size: 14px;
}
@media (min-width: 764px) {
    button {
        position: absolute;
        right: 15px;
        top: 15px;
        min-width: 150px;
        margin: 0;
    }
}

`;

export const DispatchItem = ({ order }) => {

    const {
        status,
        deliveryDate,
        trackingUrl,
        receiverName,
        timeWindow,
        isStorePickup,
        items
    } = order;

    const meses = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    const dias_semana = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
    const timeSplit = deliveryDate.split("/", 3)
    const day = timeSplit[0]
    const mes = timeSplit[1]
    const year = timeSplit[2]
    const fullDate = new Date(year, mes - 1, day)
    const Nameday = fullDate.getDay();

    const removeAccents = (str) => {
        let arr = str.toLowerCase()
        return arr.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }

    const normalizeClass = removeAccents(status.split(" ").pop())

    return (
        <DispatchStyle>
            <div className='card-header'>
                <p className='dayOf'><strong>{`${day} de ${(meses[parseInt(mes - 1)])} `}</strong> / <span className={`colored ${normalizeClass}`}><strong>{status}</strong></span></p>
            </div>
            <div className='card-body'>
                {
                    status !== 'Anulado' &&
                    <div className='order-notice'>
                        <p>Fecha {`${status != 'Finalizado' ? 'estimada' : ''}`} de entrega: <strong> {`${(dias_semana[Nameday])} ${day} de ${(meses[parseInt(mes - 1)])} de ${year} `} </strong></p>
                        <p>Horario desde {timeWindow} horas</p>
                        <p className='hide'>Despacho para: <strong>{receiverName}</strong></p>
                    </div>
                }

                {

                    items.map(product => (
                        <SimpleProduct
                            key={product.sku}
                            {...product}
                        />
                    ))

                }

                {isStorePickup ? null : (

                    <a href={trackingUrl} target="_blank">
                        <button>Ver detalle  &#8250;</button>
                    </a>
                )
                }


            </div>

        </DispatchStyle>
    )
}